var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nn-scroll-area',{attrs:{"nn-color":"royal-purple"}},[_c('pie-chart',{attrs:{"chart-data":_vm.selection.colors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }